import { Divider, Grid } from "@mui/material";
import React from "react";
import { MarkupEditor } from "../../../markupEditor";
import { CsvEditor } from "../../../../pages/diagnostic/CsvEditor";

export default function StoryWithKeywords({
  chapterData,
  isValidMarkup,
  onContentSave,
  handleChange,
  setChapterData,
  onSave,
  onUpload,
}) {
  return (
    <>
      <Grid item xs={12}>
        <Divider sx={{ pt: 2, mb: 1 }} />
        <CsvEditor
          onUpload={(sentances) => onUpload(sentances)}
          chapterId={chapterData?.chapterId}
        />
        <MarkupEditor
          onSave={onContentSave}
          content={chapterData.content}
          keyWords={chapterData.keyWords}
          irLevels={Array.from(new Array(9)).map((e, i) => `L${i}`)}
        />
        <Divider sx={{ py: 2 }} />
      </Grid>
    </>
  );
}
